import callAllFn from '@julofinance/web-helpers/dist/fn/callAllFn';

import { ApiResult } from '@models/api';
import { useMutation, UseMutationOptions } from '@hooks/react-query';
import { CustomError, fetcherMutation } from '@utils/react-query';

import { SaveForm, SaveFormParam } from '../models';

function useRSaveApplication<Type extends SaveForm>(
  options: UseMutationOptions<
    ApiResult<unknown>,
    Record<string, unknown>,
    SaveFormParam<Type>
  > = {},
) {
  const { onError, ...resOptions } = options;

  return useMutation<
    ApiResult<unknown>,
    Record<string, unknown>,
    SaveFormParam<Type>
  >({
    mutationFn: async ({ context, variables }) =>
      await fetcherMutation({
        context: { ...context, method: 'PATCH', path: 'application/v2/submit' },
        variables,
      }),
    onError: callAllFn((err: CustomError) => {
      const statusCode = err.payload?.statusCode;
      if (statusCode === 403) return window.location.replace('/home');
    }, onError),
    ...resOptions,
  });
}

export default useRSaveApplication;
